// import React, { useState, useEffect, useRef } from "react";
// import _ from "lodash";
// import { ContentState, EditorState, Modifier, SelectionState } from "draft-js";
// import DocumentService from "../../services/document";
// import { strCount } from "../Editor/utilize";
// import { useSelector } from "react-redux";
// import {
//   Accordion,
//   AccordionActions,
//   AccordionDetails,
//   AccordionSummary,
//   Button,
//   Typography,
// } from "@mui/material";
// import { BeatLoader } from "react-spinners";
// import { css } from "@emotion/react";

// import "../../utils/loader.css";
// import { is } from "immutable";

// const override = css`
//   position: absolute;
//   left: 42%;
//   top: 50%;
//   margin: 0 auto;
//   z-index: 9999;
// `;

// const SuggestionComp = ({
//   mobileView,
//   autoSaveContent,
//   docName,
//   docId,
//   newDocId,
//   folderId,
//   tags,
//   ignoreAllClicked,
//   setIgnoreAllClicked,
//   acceptAllClicked,
//   setAcceptAllClicked,
//   setEditorContentUpload,
//   editorHtmlContent,
//   changedSentence,
//   setSentenceResult,
//   setState,
//   setIsFeatureButton,
//   editorState,
//   setEditorState,
//   setIsSuggestion,
//   copiedText,
//   editor,
//   setIsType,
//   ignoredSuggestions,
//   windowWidth,
//   setOldSentences,
//   oldSentences,
//   setNewSentences,
//   newSentences,
//   suggestionLoader,
//   editorValue,
// }) => {
//   const [suggestionArray, setSuggestionArray] = useState([]);
//   const [isColorChange, setIsColorChange] = useState(true);
//   const [clickedWord, setClickedWord] = useState("");
//   const { isFullSize } = useSelector((state) => state?.manageFullSizeEditor);
//   const { isFullScreen } = useSelector((state) => state?.manageFullSizeEditor);
//   const [expanded, setExpanded] = useState();
//   const [errorValue, setErrorValue] = useState("");

//   let filterValues = [];
//   const accordionRef = useRef(null);

//   const [wordsCount, characterCount] = strCount(editorHtmlContent.toString());

//   useEffect(() => {
//     if (acceptAllClicked) {
//       handleAcceptAll(suggestionArray);
//     }
//     // setAcceptAllClicked(false)
//   }, [acceptAllClicked]);

//   useEffect(() => {
//     if (ignoreAllClicked) {
//       handleIgnoreAll(suggestionArray);
//     }
//     setIgnoreAllClicked(false);
//   }, [ignoreAllClicked]);

//   const handleIgnoreAll = async (suggestions) => {
//     suggestions.forEach(async (sentence) => {
//       let filterSentence = suggestionArray.filter(
//         (item) => item.value !== sentence.value
//       );
//       let data = {
//         phrase: sentence.corrective_text,
//       };
//       setSuggestionArray(filterSentence);

//       // Optionally, update UI based on filterSentence length
//       if (filterSentence.length === 0) {
//         setSentenceResult([]);
//         setIsSuggestion(false);
//       }

//       // Example functions colorWord and highLightWords
//       colorWord(sentence.value, sentence.errored_text, "black");
//       highLightWords(sentence.value, "white");
//     });
//     setSentenceResult([]);
//     setIsColorChange(false);
//     setIsSuggestion(false); // Depending on your UI logic
//   };

//   const handleAcceptAll = (suggestion) => {
//     let updatedHtmlContent;
//     let editorContent = editorHtmlContent;
//     suggestion.map((sentence) => {
//       let phrase = sentence.phrase;
//       let correctPhrase = sentence.corrective_text_phrase;
//       console.log(phrase, "yyyy", correctPhrase);

//       let tempElement1 = document.createElement("div");
//       tempElement1.innerHTML = editorContent
//         .split("&nbsp;")
//         .join(" ")
//         .replace(/<body[^>]*>(.*?)<\/body>/is, "<div>$1</div>")
//         .replace(/<\/?(?!p|li|table|img|tbody|tr|td|ul)([^\s>]+)[^>]*>/g, "")
//         .replace(/^<div>|<\/div>$/g, "");

//       // Function to recursively replace text nodes
//       function replaceTextNodes(node) {
//         if (node.nodeType === Node.TEXT_NODE) {
//           let text = node.textContent;
//           // Replace the phrase with the correct phrase
//           let newText = text.replace(new RegExp(phrase, "gi"), correctPhrase);
//           node.textContent = newText;
//         } else if (node.nodeType === Node.ELEMENT_NODE) {
//           // If the node is an element, recursively process its child nodes
//           for (let i = 0; i < node.childNodes.length; i++) {
//             replaceTextNodes(node.childNodes[i]);
//           }
//         }
//       }

//       // Start replacing text nodes from the top-level element
//       replaceTextNodes(tempElement1);

//       // Get the updated HTML content from the modified DOM element
//       updatedHtmlContent = tempElement1.innerHTML;
//       editorContent = tempElement1.innerHTML;
//     });

//     // Log the updated HTML content
//     console.log("Updated HTML contentyyyy:", updatedHtmlContent);
//     let editHtml = updatedHtmlContent.replace(/<\/?p>/g, "");
//     // let updatedContent = editHtml.split('.').filter(s => s.trim()).map(s => s.trim() + '.');

//     let updatedContent = editHtml
//       // Remove extra dots at the end of sentences (e.g., "sentence.." → "sentence.")
//       .replace(/\.+/g, ".")
//       // Split into sentences
//       .split(".")
//       // Remove empty strings
//       .filter((s) => s.trim())
//       // Add a dot only if missing
//       .map((s) => {
//         const trimmed = s.trim();
//         return trimmed.endsWith(".") ? trimmed : trimmed + ".";
//       });

//     // updatedContent = updatedContent.map(sentence =>
//     //     sentence.replace(/\.{2,}/g, '.') // Replace 2+ dots with a single dot
//     // );

//     console.log("updatedContent_", updatedContent, editHtml);
//     editor.current.innerHTML = updatedHtmlContent;
//     setEditorState(updatedHtmlContent);
//     setNewSentences(updatedContent);
//     setSentenceResult([]);
//     setIsColorChange(false);
//     setIsSuggestion(false);
//   };

//   const colorWord = (word, errorWord, color) => {
//     console.log("content_", editor, word, color);
//     // let content = editor.current.value;
//     let content = editor.current.innerHTML;

//     const escapedWord = word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

//     // Step 1: Remove existing spans for that word
//     const spanRemovalRegex = new RegExp(
//       `<span[^>]*?data-word=["']${errorWord}["'][^>]*?>(.*?)<\/span>`,
//       "gi"
//     );
//     content = content.replace(spanRemovalRegex, "$1");

//     // Step 2: Apply the new colored span
//     const replacement = `<span onclick="window.handleHighlightedWordClick(event,this)" data-word="${errorWord}" data-display-word="${word}" style="color: ${color}; cursor:pointer">${word}</span>`;

//     const coloredContent = content.replace(
//       new RegExp(`(${escapedWord})(?![^<]*>)`, "gi"),
//       replacement
//     );
//     // editor.current.setEditorValue(coloredContent);
//     editor.current.innerHTML = coloredContent;
//   };
//   // const colorWord = (word, errorWord, color) => {
//   //   console.log('editor_text',editor.current)
//   //   if (!editor.current) return;
//   //   let content = editor.current.innerHTML;
//   //   const escaped = word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
//   //   // remove all previous spans
//   //   content = content.replace(/<span[^>]*>(.*?)<\/span>/gi, "$1");
//   //   const replacement = `<span onclick="handleHighlightedWordClick(event)" data-word="${escaped}" style="color:${color}; cursor:pointer">${word}</span>`;
//   //   content = content.replace(new RegExp(`(${escaped})`, "gi"), replacement);
//   //   editor.current.innerHTML = content;
//   // };

//   // window.handleHighlightedWordClick = (event) => {
//   //   console.log("event_",event)
//   //   event.preventDefault();
//   //   const word = decodeURIComponent(event.target.dataset.word);
//   //   const clickedDisplayWord = event.target.dataset.displayWord;
//   //   // 1. Get the clicked word (you can use it for further logic)
//   //   console.log("Clicked word:", word, clickedDisplayWord);
//   //   // 2. Find the accordion section related to this word and scroll to it
//   //   scrollToAccordion(word, clickedDisplayWord);
//   // };

//   window.handleHighlightedWordClick = (event, el) => {
//     event.preventDefault();
//     event.stopPropagation();

//     const word = decodeURIComponent(el.dataset.word);
//     const clickedDisplayWord = el.dataset.displayWord;

//     console.log("Clicked word:", word, clickedDisplayWord);

//     scrollToAccordion(word, clickedDisplayWord);
//   };

//   const highLightWords = (word, color) => {
//     // const content = editor.current.value;
//     let content = editor.current.innerHTML;

//     const escapedWord = word?.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
//     const replacement = `<span style="background-color:${color};">${word}</span>`;

//     const coloredContent = content?.replace(
//       new RegExp(`(${escapedWord})(?![^<]*>)`, "gi"), // Ensure not inside HTML tags
//       replacement
//     );
//     // Set the updated content in the editor
//     const selection = window.getSelection();
//     selection.removeAllRanges();
//     editor.current.innerHTML = coloredContent;
//     // editor.current.setEditorValue(coloredContent);
//   };

//   const scrollToAccordion = (word, displayword) => {
//     console.log("clicked_Word_", word, displayword);
//     // setExpanded(word)
//     // Find all accordion items that match the word (since multiple suggestions might exist)
//     const accordionItems = document.querySelectorAll(
//       `.cgsuggestion [id^="accordion-"]`
//     );
//     let foundItem = null;
//     // Find the first accordion that contains this word
//     accordionItems.forEach((item) => {
//       // The ID format is "accordion-{errored_text}"
//       const erroredText = item.id.replace("accordion-", "");
//       if (erroredText === word && !foundItem) {
//         foundItem = item;
//       }
//     });
//     console.log("foundItem_", foundItem);
//     if (foundItem) {
//       // Scroll to the accordion item
//       foundItem.scrollIntoView({
//         behavior: "smooth",
//         block: "center",
//       });

//       // Visual feedback - highlight the accordion
//       const accordionSummary = foundItem.querySelector(
//         ".MuiAccordionSummary-root"
//       );
//       if (accordionSummary) {
//         accordionSummary.style.backgroundColor = "#e6f7ff";

//         // Remove highlight after 1 second
//         setTimeout(() => {
//           accordionSummary.style.backgroundColor = "";
//         }, 1000);
//       }

//       // Optional: Expand the accordion
//       if (expanded !== word) {
//         setExpanded(word);
//         highLightWords(displayword, "#c0f5b8");
//       }
//     }
//   };

//   // const handleAccept = (sentence) => {
//   //   console.log("sentence_", sentence);
//   //   let phrase = sentence.phrase;
//   //   let correctPhrase = sentence.corrective_text_phrase;
//   //   console.log(phrase, "yyyy_", correctPhrase);

//   //   let tempElement1 = document.createElement("div");
//   //   tempElement1.innerHTML = editorHtmlContent
//   //     .split("&nbsp;")
//   //     .join(" ")
//   //     .replace(/<body[^>]*>(.*?)<\/body>/is, "<div>$1</div>")
//   //     .replace(/<\/?(?!p|li|table|img|tbody|tr|td|ul)([^\s>]+)[^>]*>/g, "")
//   //     .replace(/^<div>|<\/div>$/g, "");

//   //   // Function to recursively replace text nodes
//   //   function replaceTextNodes(node) {
//   //     if (node.nodeType === Node.TEXT_NODE) {
//   //       let text = node.textContent;
//   //       // Replace the phrase with the correct phrase
//   //       let newText = text.replace(new RegExp(phrase, "gi"), correctPhrase);
//   //       node.textContent = newText;
//   //     } else if (node.nodeType === Node.ELEMENT_NODE) {
//   //       // If the node is an element, recursively process its child nodes
//   //       for (let i = 0; i < node.childNodes.length; i++) {
//   //         replaceTextNodes(node.childNodes[i]);
//   //       }
//   //     }
//   //   }

//   //   // Start replacing text nodes from the top-level element
//   //   replaceTextNodes(tempElement1);

//   //   // Get the updated HTML content from the modified DOM element
//   //   let updatedHtmlContent = tempElement1.innerHTML;

//   //   // Log the updated HTML content
//   //   console.log("Updated HTML contentyyyy:", updatedHtmlContent);

//   //   // Update the editor content
//   //    editor.current.innerHTML = updatedHtmlContent

//   //   const socketData = {
//   //     documentName: docName,
//   //     documentId: docId ? docId : newDocId,
//   //     onlyDocumentContent: updatedHtmlContent,
//   //     formattedDocumentContent: updatedHtmlContent,
//   //     wordsCount,
//   //     characterCount,
//   //     folder: folderId ? folderId : null,
//   //     tags: tags,
//   //   };

//   //   // autoSaveContent(socketData)

//   //   let givenInput = editorState;
//   //   // const htmlContent = editor.current.value; // Access the HTML content
//   //   const htmlContent = editor.current?.innerHTML || "";
//   //   const tempElement = document.createElement("span");
//   //   tempElement.innerHTML = htmlContent;
//   //   // Extract text content
//   //   const textContent = tempElement.textContent || tempElement.innerText;
//   //   // Replace all occurrences of the original word with the replacement word
//   //   const replacedContent = textContent.replace(
//   //     new RegExp(`\\b${phrase}\\b`, "gi"),
//   //     sentence.corrective_text_phrase
//   //   );
//   //   const updatedContent = textContent.replace(
//   //     phrase,
//   //     sentence.corrective_text_phrase
//   //   );

//   //   // editor.current.setEditorValue(updatedContent);

//   //   console.log(
//   //     "updatedSingleContent_",
//   //     updatedContent,
//   //     newSentences,
//   //     oldSentences
//   //   );
//   //   setNewSentences((prevItems) => [
//   //     ...prevItems,
//   //     sentence.corrective_text_phrase,
//   //   ]);

//   //   let content = updatedContent.replace(/\n/g, "");
//   //   editor.current.innerHTML = content

//   //   // editor.current.setEditorValue(content);

//   //   // const startIndex = replacedContent.indexOf(sentence.corrective_text);
//   //   // const endIndex = startIndex + sentence.corrective_text.length;

//   //   // Scroll to the selection range
//   //   const selection = window.getSelection();
//   //   selection.removeAllRanges();
//   //   // selection.addRange();
//   //   const currentPosition = selection.focusOffset;

//   //   // for Suggestion change
//   //   let filterSentence = _.filter(
//   //     suggestionArray,
//   //     (item, i) => item.corrective_text !== sentence.corrective_text
//   //   );
//   //   if (filterSentence.length == 0) {
//   //     setSentenceResult([]);
//   //     setIsColorChange(false);
//   //     setIsSuggestion(false);
//   //   }

//   //   setSuggestionArray(filterSentence);
//   // };

//   // const handleAccept = (sentence) => {
//   //   if (!editor.current) return;

//   //   let phrase = sentence.phrase;
//   //   let correctPhrase = sentence.corrective_text_phrase;

//   //   console.log("Accept:", phrase, "→", correctPhrase);

//   //   const root = editor.current;

//   //   // normalize nbsp
//   //   const html = root.innerHTML.replace(/&nbsp;/g, " ");

//   //   const escaped = phrase.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

//   //   const updatedHtml = html.replace(
//   //     new RegExp(`\\b${escaped}\\b`, "gi"),
//   //     correctPhrase
//   //   );

//   //   console.log("Updated:", updatedHtml);

//   //   root.innerHTML = updatedHtml;

//   //   // update suggestion list
//   //   const filterSentence = suggestionArray.filter(
//   //     (item) => item.corrective_text !== sentence.corrective_text
//   //   );

//   //   if (filterSentence.length === 0) {
//   //     setSentenceResult([]);
//   //     setIsColorChange(false);
//   //     setIsSuggestion(false);
//   //   }

//   //   setSuggestionArray(filterSentence);
//   //   setNewSentences((prev) => [...prev, correctPhrase]);
//   // };

//   const handleAccept = (sentence) => {
//     if (!editor.current) return;

//     console.log("Accept sentence:", sentence, "→", correctSentence);

//     const wrongSentence = sentence.phrase; // wrong full sentence
//     const correctSentence = sentence.corrective_text_phrase; // correct full sentence

//     console.log("Accept sentence:", wrongSentence, "→", correctSentence);

//     const root = editor.current;

//     // 1. Get plain text (removes span interference)
//     const text = root.innerText;

//     console.log("text_",text)

//     const escaped = wrongSentence?.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

//     // 2. Replace sentence in plain text
//     const updatedText = text.replace(
//       new RegExp(escaped, "gi"),
//       correctSentence
//     );

//     console.log("Updated text:", updatedText);

//     // 3. Set back as HTML (removes highlight spans)
//     root.innerHTML = updatedText;

//     // 4. Update suggestion list
//     const filterSentence = suggestionArray.filter(
//       (item) => item.corrective_text !== sentence.corrective_text
//     );

//     if (filterSentence.length === 0) {
//       setSentenceResult([]);
//       setIsColorChange(false);
//       setIsSuggestion(false);
//     }

//     setSuggestionArray(filterSentence);
//     setNewSentences((prev) => [...prev, correctSentence]);
//   };

//   const handleIgnore = async (sentence) => {
//     let filterSentence = _.filter(
//       suggestionArray,
//       (item, i) => item.value !== sentence.value
//     );
//     let data = {
//       phrase: sentence.corrective_text,
//     };
//     // const response = await DocumentService.saveIgnoredSuggestions(data)
//     // console.log(response, "response from save phrase");
//     if (filterSentence.length == 0) {
//       setSentenceResult([]);
//       setIsSuggestion(false);
//     }
//     colorWord(sentence.value, sentence.errored_text, "black");
//     highLightWords(sentence.value, "white");
//     setSuggestionArray(filterSentence);
//   };

//   useEffect(() => {
//     // console.log("changedSentence_", changedSentence)
//     if (changedSentence?.length > 0) {
//       handleFilterValues(changedSentence);
//     }
//   }, [changedSentence]);

//   const handleFilterValues = (sentence) => {
//     // console.log("changedSentence_", sentence)
//     sentence.map((item, i) => {
//       // console.log("item_", item, i)
//       filterValues.push({
//         corrective_text:
//           item["corrective_text"] || item["corrective_text_phrase"],
//         corrective_text_phrase: item["corrective_text_phrase"] || "",
//         justification: item["justification"] || "",
//         phrase: item["phrase"] || "",
//         type_of_error: item["type_of_error"] || "",
//         value: item["value"],
//         errored_text: item["errored_text"],
//       });
//     });

//     // console.log("filterValues_", filterValues)
//     let filterSentence = _.filter(
//       filterValues,
//       (item) =>
//         item["type_of_error"] !== "No error" &&
//         item["type_of_error"] !== "No errors" &&
//         item["type_of_error"] !== "None" &&
//         item["type_of_error"] !== "N/A" &&
//         item["type_of_error"] !== "none" &&
//         item["justification"] !== "No grammatical errors found." &&
//         item["justification"] !== "No error found in the phrase." &&
//         item["justification"] !== "" &&
//         item["justification"] !== "The sentence is grammatically correct." &&
//         item["corrective_text"] !== ""
//     );
//     // console.log("filterSentence_", filterSentence)

//     let finalFilteredValues = filterSentence.filter(
//       (suggestion) => !ignoredSuggestions.includes(suggestion.corrective_text)
//     );

//     console.log("finalFilteredValues_", finalFilteredValues);

//     const values = finalFilteredValues.map((item) => item.phrase);
//     const correctedSentences = values.map(
//       (sentence) =>
//         sentence
//           .replace(/\.+/g, ".")
//           // Split into sentences
//           .split(".")
//           // Remove empty strings
//           .filter((s) => s.trim())
//           // Add a dot only if missing
//           .map((s) => {
//             const trimmed = s.trim();
//             return trimmed.endsWith(".") ? trimmed : trimmed + ".";
//           }) // Replace 2+ dots with a single dot
//     );
//     const flatArray = correctedSentences.flat();

//     console.log("valuesAdded_", newSentences, correctedSentences, flatArray);
//     // setNewSentences([...newSentences,...correctedSentences]);
//     setNewSentences((prevItems) => [...prevItems, ...flatArray]);

//     if (filterSentence.length == 0) {
//       setSentenceResult([]);
//       setIsSuggestion(false);
//     } else {
//       if (suggestionArray.length == 0) {
//         setSuggestionArray(finalFilteredValues);
//       } else {
//         setSuggestionArray((prevSentences) => {
//           const flattenedNewSentences = finalFilteredValues.flat();
//           const merged = [...prevSentences, ...flattenedNewSentences];

//           const seen = new Map();
//           const uniqueArray = merged.filter((obj) => {
//             if (!seen.has(obj.value)) {
//               seen.set(obj.value, true);
//               return true;
//             }
//             return false;
//           });

//           return uniqueArray;
//         });
//       }
//       setIsSuggestion(true);
//     }
//   };
//   useEffect(() => {
//     console.log("suggestionArray_", suggestionArray);
//     if (suggestionArray.length > 0) {
//       suggestionArray.map((item, i) => {
//         // if (item.type_of_error != 'None' || item.type_of_error != 'No error') {
//         colorWord(item.value, item.errored_text, "red");
//         // }
//       });
//       setExpanded(suggestionArray[0].errored_text);
//       setErrorValue(suggestionArray[0].value);
//       highLightWords(suggestionArray[0].value, "#c0f5b8");
//     }
//   }, [suggestionArray]);

//   const handleExpand = (param) => {
//     console.log("expanded_", expanded);
//     setErrorValue(param.value);
//     if (param.value !== errorValue) {
//       highLightWords(errorValue, "white");
//     }
//     setExpanded(param.errored_text);
//     highLightWords(param.value, "#c0f5b8");
//   };

//   return (
//     <div
//       style={{
//         maxHeight: "70vh",
//         overflowY: "auto",
//         overflowX: "hidden",
//         padding: "9px",
//         marginTop: "40px",
//       }}
//     >
//       <div className={suggestionLoader ? "suggestion-loading-overlay" : ""}>
//         <BeatLoader
//           css={override}
//           sizeUnit={"px"}
//           size={20}
//           color={"#123abc"}
//           loading={suggestionLoader}
//         />
//       </div>
//       {suggestionArray.length > 0 &&
//         suggestionArray.map((suggestion, i) => {
//           return (
//             <>
//               {/* <div
//                             className="my-4 highlighted-suggestion"
//                             style={{
//                                 backgroundColor: "#ffffff",
//                                 borderRadius: "8px",
//                                 boxShadow: " 0 0px 0px 1px black",
//                                 padding: "9px",
//                             }}
//                             onMouseOver={() => highLightWords(suggestion.value, "#fddfde")}
//                             onMouseLeave={() => highLightWords(suggestion.value, "white")}
//                         >

//                             <div className="row">
//                                 <div className="col-md-3"
//                                     style={{
//                                         fontFamily: 'Poppins, sans-serif',
//                                         fontWeight: 500,
//                                         // color: "#EA1537",
//                                         fontSize: "12px",
//                                         // textDecoration: "line-through",
//                                     }}
//                                 >
//                                 </div>
//                                 <div className="col-md-9 d-flex justify-content-end"
//                                 >
//                                     <button style={{ borderRadius: '10px', color: "#BA18B5", backgroundColor: '#FEDAF6', padding: '5px' }}><b>{suggestion.type_of_error.charAt(0).toUpperCase() + suggestion.type_of_error.slice(1)}</b></button>
//                                 </div>
//                             </div>
//                             <div className="row mt-3">
//                                 <div className="col-md-12"
//                                     style={{
//                                         fontFamily: 'Poppins, sans-serif',
//                                         fontWeight: 500,
//                                         color: "#676767",
//                                         fontSize: "13px",
//                                     }}
//                                 >
//                                     <p style={{ color: "#EA1537", display: "inline", fontSize: mobileView ? '10px' : '' }} >{suggestion.value} </p><br />
//                                     <p style={{ color: "#676767", fontSize: mobileView ? '11px' : '13px', fontWeight: "600", display: "inline" }}>Replace with:</p><br />
//                                     <p style={{ color: "green", display: "inline", marginLeft: "2%", fontSize: mobileView ? '10px' : '' }} >"{suggestion.corrective_text}"</p>

//                                 </div>
//                             </div>
//                             <div className="mt-2">
//                                 <p style={{ color: "#676767", fontSize: mobileView ? '11px' : '13px', fontWeight: "600", display: "inline" }}>Justification :</p><br />
//                                 <p style={{ color: "#007bff", fontSize: "12px", display: "inline", marginLeft: "3px", fontSize: mobileView ? '10px' : '' }} >{suggestion?.justification}</p>
//                             </div>
//                             <div className="row mt-3 mr-0" style={{ display: mobileView ? 'flex' : '', flexWrap: mobileView ? 'nowrap' : '', justifyContent: mobileView ? 'flex-end' : 'flex-end' }}>
//                                 <div className="col-md-3">
//                                     <button className="btn btn-outline primary" style={{ borderRadius: '10px', border: '1px solid grey', fontSize: mobileView ? '10px' : '' }}
//                                         onClick={() => handleIgnore(suggestion)}
//                                     >Ignore</button>
//                                 </div>
//                                 <div className="col-md-3 ">
//                                     <button className="btn btn-primary" style={{ borderRadius: '10px', fontSize: mobileView ? '10px' : '' }}
//                                         onClick={() => handleAccept(suggestion)}
//                                     >Accept</button>
//                                 </div>
//                             </div>
//                         </div> 
//                 ---------end of old code --------------  
//                 */}

//               {/* ---------  new accordion changes --------- */}
//               <div className="cgsuggestion" ref={accordionRef}>
//                 <Accordion
//                   expanded={expanded == suggestion.errored_text}
//                   onChange={() => handleExpand(suggestion)}
//                   id={`accordion-${suggestion.errored_text}`}
//                   // onClick={()=>highLightWords(suggestion.value, "#fddfde")}
//                   // onMouseOver={() => highLightWords(suggestion.value, "#fddfde")}
//                   // onMouseLeave={() => highLightWords(suggestion.value, "white")}
//                 >
//                   <AccordionSummary
//                     // expandIcon={<ExpandMoreIcon />}
//                     aria-controls="panel3-content"
//                     id="panel3-header"
//                   >
//                     <div className="d-flex col-md-12 pt-2 px-0 justify-content-between">
//                       <div className="errorvalue">
//                         {suggestion.errored_text}
//                       </div>
//                       <div className="typeoferror">
//                         {suggestion.type_of_error?.charAt(0).toUpperCase() +
//                           suggestion.type_of_error?.slice(1)}
//                       </div>
//                     </div>
//                   </AccordionSummary>
//                   <AccordionDetails>
//                     <div className="d-flex col-md-12 p-0 justify-content-evenly">
//                       <p
//                         style={{
//                           color: "#676767",
//                           fontSize: mobileView ? "11px" : "13px",
//                           fontWeight: "600",
//                           display: "inline",
//                         }}
//                       >
//                         Replace with:
//                       </p>
//                       <br />
//                       <p
//                         style={{
//                           color: "green",
//                           display: "inline",
//                           marginLeft: "2%",
//                           fontSize: mobileView ? "10px" : "",
//                         }}
//                       >
//                         "{suggestion.corrective_text}"
//                       </p>
//                     </div>
//                     <div className="mt-2">
//                       <p
//                         style={{
//                           color: "#676767",
//                           fontSize: mobileView ? "11px" : "13px",
//                           fontWeight: "600",
//                           display: "inline",
//                         }}
//                       >
//                         Justification :
//                       </p>
//                       <br />
//                       <p
//                         style={{
//                           color: "#007bff",
//                           fontSize: "12px",
//                           display: "inline",
//                           marginLeft: "3px",
//                           fontSize: mobileView ? "10px" : "",
//                         }}
//                       >
//                         {suggestion?.justification}
//                       </p>
//                     </div>
//                   </AccordionDetails>
//                   <AccordionActions>
//                     <Button
//                       className="cgcancelbtn"
//                       size="small"
//                       variant="outlined"
//                       color="error"
//                       onClick={() => handleIgnore(suggestion)}
//                     >
//                       Ignore
//                     </Button>
//                     <Button
//                       className="cgacceptbtn"
//                       size="small"
//                       variant="contained"
//                       color="success"
//                       onClick={() => handleAccept(suggestion)}
//                     >
//                       Accept
//                     </Button>
//                   </AccordionActions>
//                 </Accordion>
//               </div>
//               {/* ----------- end of new accordion changes ------ */}

//               {/* <div key={i} className="cgsuggestion" ref={accordionRef}>
//                             <Accordion
//                                 expanded={expanded === suggestion.errored_text}
//                                 onChange={() => {
//                                     handleExpand(suggestion);
//                                     highLightWords(suggestion.errored_text, "#fddfde");
//                                 }}
//                                 id={`accordion-${suggestion.errored_text}`}
//                                 // onMouseEnter={() => highLightWords(suggestion.errored_text, "#fddfde")}
//                                 // onMouseLeave={() => removeHighlights(suggestion.errored_text)}
//                             >
//                                 <AccordionSummary
//                                     aria-controls={`panel-${i}-content`}
//                                     id={`panel-${i}-header`}
//                                     onClick={(e) => {
//                                         e.stopPropagation();
//                                         highLightWords(suggestion.errored_text, "#fddfde");
//                                         // scrollToEditorWord(suggestion.errored_text);
//                                     }}
//                                 >
//                                     <div className="d-flex col-md-12 pt-2 px-0 justify-content-between">
//                                         <div className="errorvalue">
//                                             {suggestion.errored_text}
//                                         </div>
//                                         <div className="typeoferror">
//                                             {suggestion.type_of_error.charAt(0).toUpperCase() + suggestion.type_of_error.slice(1)}
//                                         </div>
//                                     </div>
//                                 </AccordionSummary>
//                                 <AccordionDetails>
//                                     <div className="d-flex col-md-12 p-0 justify-content-evenly">
//                                         <p style={{ color: "#676767", fontSize: mobileView ? '11px' : '13px', fontWeight: "600" }}>
//                                             Replace with:
//                                             <span style={{ color: "green", marginLeft: "2%", fontSize: mobileView ? '10px' : '' }}>
//                                                 "{suggestion.corrective_text}"
//                                             </span>
//                                         </p>
//                                     </div>
//                                     <div className="mt-2">
//                                         <p style={{ color: "#676767", fontSize: mobileView ? '11px' : '13px', fontWeight: "600" }}>
//                                             Justification:
//                                             <span style={{ color: "#007bff", marginLeft: "3px", fontSize: mobileView ? '10px' : '' }}>
//                                                 {suggestion?.justification}
//                                             </span>
//                                         </p>
//                                     </div>
//                                 </AccordionDetails>
//                                 <AccordionActions>
//                                     <Button
//                                         className="cgcancelbtn"
//                                         size="small"
//                                         variant="outlined"
//                                         color="error"
//                                         onClick={(e) => {
//                                             e.stopPropagation();
//                                             handleIgnore(suggestion);
//                                         }}
//                                     >
//                                         Ignore
//                                     </Button>
//                                     <Button
//                                         className="cgacceptbtn"
//                                         size="small"
//                                         variant="contained"
//                                         color="success"
//                                         onClick={(e) => {
//                                             e.stopPropagation();
//                                             handleAccept(suggestion);
//                                         }}
//                                     >
//                                         Accept
//                                     </Button>
//                                 </AccordionActions>
//                             </Accordion>
//                         </div> */}
//             </>
//           );
//         })}
//     </div>
//   );
// };
// export default SuggestionComp;



import React, { useState, useEffect, useRef } from "react";
import _ from "lodash";
import { ContentState, EditorState, Modifier, SelectionState } from "draft-js";
import DocumentService from "../../services/document";
import { strCount } from "../Editor/utilize";
import { useSelector } from "react-redux";
import {
  Accordion,
  AccordionActions,
  AccordionDetails,
  AccordionSummary,
  Button,
  Typography,
  Box,
  Chip,
  Divider,
  LinearProgress,
  Tooltip,
  Fade,
} from "@mui/material";
import { BeatLoader } from "react-spinners";
import { css } from "@emotion/react";
import GrammarIcon from "@mui/icons-material/Spellcheck";
import StyleIcon from "@mui/icons-material/AutoFixHigh";
import ClarityIcon from "@mui/icons-material/Visibility";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// ─── DESIGN TOKENS ──────────────────────────────────────────────────────────
const C = {
  bg: "#f0f2f8",
  surface: "#ffffff",
  border: "rgba(99,120,180,0.14)",
  accent: "#4f6ef7",
  accentLight: "#cdd3ee",
  success: "#22c55e",
  successLight: "#f0fdf4",
  error: "#ef4444",
  errorLight: "#fef2f2",
  warning: "#f59e0b",
  warningLight: "#fffbeb",
  purple: "#8b5cf6",
  purpleLight: "#f5f3ff",
  textPrimary: "#1a1d2e",
  textSecondary: "#64748b",
  textMuted: "#434343",
};

const R = { sm: "8px", md: "12px", lg: "16px" };

// ─── ERROR TYPE CONFIG ────────────────────────────────────────────────────────
const getErrorConfig = (type = "") => {
  const t = type.toLowerCase();
  if (t.includes("grammar") || t.includes("grammatical"))
    return { color: C.error, bg: C.errorLight, label: "Grammar", icon: <GrammarIcon sx={{ fontSize: 13 }} /> };
  if (t.includes("spell"))
    return { color: C.warning, bg: C.warningLight, label: "Spelling", icon: <GrammarIcon sx={{ fontSize: 13 }} /> };
  if (t.includes("style"))
    return { color: C.purple, bg: C.purpleLight, label: "Style", icon: <StyleIcon sx={{ fontSize: 13 }} /> };
  if (t.includes("clarity"))
    return { color: C.accent, bg: C.accentLight, label: "Clarity", icon: <ClarityIcon sx={{ fontSize: 13 }} /> };
  return { color: C.textSecondary, bg: "#f8fafc", label: type || "Issue", icon: <SwapHorizIcon sx={{ fontSize: 13 }} /> };
};

const override = css`
  position: absolute;
  left: 42%;
  top: 50%;
  margin: 0 auto;
  z-index: 9999;
`;

// ─── EMPTY STATE ─────────────────────────────────────────────────────────────
const EmptyState = () => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      py: 6,
      px: 3,
      gap: 1.5,
    }}
  >
    <Box
      sx={{
        width: 56,
        height: 56,
        borderRadius: "50%",
        bgcolor: C.successLight,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        mb: 0.5,
      }}
    >
      <CheckCircleOutlineIcon sx={{ fontSize: 28, color: C.success }} />
    </Box>
    <Typography sx={{ fontWeight: 700, color: C.textPrimary, fontSize: "0.95rem" }}>
      All good!
    </Typography>
    <Typography sx={{ color: C.textMuted, fontSize: "0.82rem", textAlign: "center", lineHeight: 1.5 }}>
      No suggestions found. Your writing looks great.
    </Typography>
  </Box>
);

// ─── SUGGESTION CARD ─────────────────────────────────────────────────────────
const SuggestionCard = ({
  suggestion,
  expanded,
  onExpand,
  onAccept,
  onIgnore,
  mobileView,
}) => {
  const config = getErrorConfig(suggestion.type_of_error);

  return (
    <Accordion
      expanded={expanded === suggestion.errored_text}
      onChange={() => onExpand(suggestion)}
      id={`accordion-${suggestion.errored_text}`}
      disableGutters
      elevation={0}
      sx={{
        border: `1.5px solid ${expanded === suggestion.errored_text ? config.color + "40" : C.border}`,
        borderRadius: `${R.md} !important`,
        mb: 1.25,
        overflow: "hidden",
        transition: "all 0.2s ease",
        "&:before": { display: "none" },
        "&.Mui-expanded": {
          boxShadow: `0 4px 16px ${config.color}18`,
        },
      }}
    >
      <AccordionSummary
        expandIcon={
          <ExpandMoreIcon
            sx={{
              fontSize: 18,
              color: expanded === suggestion.errored_text ? config.color : C.textMuted,
              transition: "color 0.2s",
            }}
          />
        }
        sx={{
          px: 2,
          py: 0.5,
          minHeight: 52,
          bgcolor: expanded === suggestion.errored_text ? config.bg : C.surface,
          transition: "background-color 0.2s",
          "&:hover": { bgcolor: config.bg },
          "& .MuiAccordionSummary-content": { margin: "10px 0", alignItems: "center", gap: 1 },
        }}
      >
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "0.83rem",
              color: config.color,
              textDecoration: "line-through",
              textDecorationColor: config.color + "80",
              letterSpacing: "-0.01em",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {suggestion.errored_text}
          </Typography>
        </Box>
        <Chip
          icon={config.icon}
          label={config.label}
          size="small"
          sx={{
            height: 22,
            fontSize: "0.7rem",
            fontWeight: 700,
            bgcolor: config.bg,
            color: config.color,
            border: `1px solid ${config.color}30`,
            "& .MuiChip-icon": { color: config.color, ml: 0.5 },
            flexShrink: 0,
          }}
        />
      </AccordionSummary>

      <AccordionDetails
        sx={{
          px: 2,
          py: 1.5,
          bgcolor: C.surface,
          borderTop: `1px solid ${C.border}`,
        }}
      >
        {/* Replace with */}
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            gap: 1,
            mb: 1.5,
            p: 1.25,
            borderRadius: R.sm,
            bgcolor: C.accentLight,
            border: `1px solid ${C.accent}25`,
          }}
        >
          <SwapHorizIcon sx={{ fontSize: 16, color: C.accent, mt: 0.15, flexShrink: 0 }} />
          <Box>
            <Typography
              sx={{ fontSize: "0.72rem", fontWeight: 600, color: C.textMuted, mb: 0.25, textTransform: "uppercase", letterSpacing: "0.04em" }}
            >
              Replace with
            </Typography>
            <Typography
              sx={{ fontSize: "0.85rem", fontWeight: 700, color: C.accent }}
            >
              &ldquo;{suggestion.corrective_text}&rdquo;
            </Typography>
          </Box>
        </Box>

        {/* Justification */}
        {suggestion.justification && (
          <Box sx={{ mb: 0.5 }}>
            <Typography
              sx={{ fontSize: "0.72rem", fontWeight: 600, color: C.textMuted, mb: 0.5, textTransform: "uppercase", letterSpacing: "0.04em" }}
            >
              Why
            </Typography>
            <Typography
              sx={{ fontSize: "0.82rem", color: C.textSecondary, lineHeight: 1.55 }}
            >
              {suggestion.justification}
            </Typography>
          </Box>
        )}
      </AccordionDetails>

      <AccordionActions
        sx={{
          px: 2,
          py: 1.25,
          bgcolor: "#fafbff",
          borderTop: `1px solid ${C.border}`,
          gap: 1,
        }}
      >
        <Button
          size="small"
          variant="outlined"
          onClick={() => onIgnore(suggestion)}
          sx={{
            borderRadius: R.md,
            textTransform: "none",
            fontWeight: 600,
            fontSize: "0.78rem",
            flex: 1,
            borderWidth: 1.5,
            borderColor: C.error + "60",
            color: C.error,
            "&:hover": {
              borderColor: C.error,
              bgcolor: C.errorLight,
            },
          }}
        >
          Ignore
        </Button>
        <Button
          size="small"
          variant="contained"
          onClick={() => onAccept(suggestion)}
          sx={{
            borderRadius: R.md,
            textTransform: "none",
            fontWeight: 600,
            fontSize: "0.78rem",
            flex: 1,
            bgcolor: C.accent,
            boxShadow: "none",
            "&:hover": {
              bgcolor: C.accentDark,
              boxShadow: "none",
            },
          }}
        >
          Accept
        </Button>
      </AccordionActions>
    </Accordion>
  );
};

// ────────────────────────────────────────────────────────────────────────────
// MAIN SuggestionComp
// ────────────────────────────────────────────────────────────────────────────
const SuggestionComp = ({
  mobileView,
  autoSaveContent,
  docName,
  docId,
  newDocId,
  folderId,
  tags,
  ignoreAllClicked,
  setIgnoreAllClicked,
  acceptAllClicked,
  setAcceptAllClicked,
  setEditorContentUpload,
  editorContent,
  changedSentence,
  setSentenceResult,
  setState,
  setIsFeatureButton,
  editorState,
  setEditorState,
  setIsSuggestion,
  copiedText,
  editor,
  setIsType,
  ignoredSuggestions,
  windowWidth,
  setOldSentences,
  oldSentences,
  setNewSentences,
  newSentences,
  suggestionLoader,
  editorValue,
}) => {
  const escapeRegex = (value = "") =>
    value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  const [suggestionArray, setSuggestionArray] = useState([]);
  const [isColorChange, setIsColorChange] = useState(true);
  const [clickedWord, setClickedWord] = useState("");
  const { isFullSize } = useSelector((state) => state?.manageFullSizeEditor);
  const { isFullScreen } = useSelector((state) => state?.manageFullSizeEditor);
  const [expanded, setExpanded] = useState();
  const [errorValue, setErrorValue] = useState("");

  let filterValues = [];
  const accordionRef = useRef(null);

  const [wordsCount, characterCount] = strCount(editorContent.toString());

  // ── all original logic (unchanged) ──────────────────────────────────────
  useEffect(() => { if (acceptAllClicked) handleAcceptAll(suggestionArray); }, [acceptAllClicked]);
  useEffect(() => { if (ignoreAllClicked) handleIgnoreAll(suggestionArray); setIgnoreAllClicked(false); }, [ignoreAllClicked]);

  const handleIgnoreAll = async (suggestions) => {
    suggestions.forEach(async (sentence) => {
      let filterSentence = suggestionArray.filter((item) => item.value !== sentence.value);
      setSuggestionArray(filterSentence);
      if (filterSentence.length === 0) { setSentenceResult([]); setIsSuggestion(false); }
      colorWord(sentence.value, sentence.errored_text, "black");
      highLightWords(sentence.value, "white");
    });
    setSentenceResult([]);
    setIsColorChange(false);
    setIsSuggestion(false);
  };

  const handleAcceptAll = (suggestion) => {
    if (!Array.isArray(suggestion) || suggestion.length === 0 || !editor.current) {
      setAcceptAllClicked(false);
      return;
    }

    let updatedHtmlContent = editorContent || editor.current.innerHTML || "";
    let editorContentNew = updatedHtmlContent;

    suggestion.forEach((sentence) => {
      const phrase = sentence?.phrase || sentence?.value || "";
      const correctPhrase =
        sentence?.corrective_text_phrase || sentence?.corrective_text || "";

      if (!phrase || !correctPhrase) return;

      let tempElement1 = document.createElement("div");
      tempElement1.innerHTML = (editorContentNew || "")
        .split("&nbsp;").join(" ")
        .replace(/<body[^>]*>(.*?)<\/body>/is, "<div>$1</div>")
        .replace(/<\/?(?!p|li|table|img|tbody|tr|td|ul)([^\s>]+)[^>]*>/g, "")
        .replace(/^<div>|<\/div>$/g, "");
      function replaceTextNodes(node) {
        if (node.nodeType === Node.TEXT_NODE) {
          node.textContent = node.textContent.replace(
            new RegExp(escapeRegex(phrase), "gi"),
            correctPhrase,
          );
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          for (let i = 0; i < node.childNodes.length; i++) replaceTextNodes(node.childNodes[i]);
        }
      }
      replaceTextNodes(tempElement1);
      updatedHtmlContent = tempElement1.innerHTML;
      editorContentNew = tempElement1.innerHTML;
    });

    if (!updatedHtmlContent) {
      setAcceptAllClicked(false);
      return;
    }

    let editHtml = updatedHtmlContent.replace(/<\/?p>/g, "");
    let updatedContent = editHtml
      .replace(/\.+/g, ".")
      .split(".")
      .filter((s) => s.trim())
      .map((s) => { const trimmed = s.trim(); return trimmed.endsWith(".") ? trimmed : trimmed + "."; });

    editor.current.innerHTML = updatedHtmlContent;
    setEditorState(updatedHtmlContent);
    setNewSentences(updatedContent);
    setSentenceResult([]);
    setAcceptAllClicked(false);
    setIsColorChange(false);
    setIsSuggestion(false);
  };

  const colorWord = (word, errorWord, color) => {
    if (!editor.current) return;

    let content = editor.current.innerHTML;
    const escapedWord = escapeRegex(word);
    const rawErrorWord = errorWord || "";
    const encodedErrorWord = encodeURIComponent(rawErrorWord);
    const encodedDisplayWord = encodeURIComponent(word || "");
    const escapedRawErrorWord = escapeRegex(rawErrorWord);
    const escapedEncodedErrorWord = escapeRegex(encodedErrorWord);
    const spanRemovalRegex = new RegExp(
      `<span[^>]*?data-word=["'](?:${escapedRawErrorWord}|${escapedEncodedErrorWord})["'][^>]*?>(.*?)<\\/span>`,
      "gi",
    );
    content = content.replace(spanRemovalRegex, "$1");
    const replacement = `<span onclick="window.handleHighlightedWordClick(event,this)" data-word="${encodedErrorWord}" data-display-word="${encodedDisplayWord}" style="color: ${color}; cursor:pointer">${word}</span>`;
    const coloredContent = content.replace(new RegExp(`(${escapedWord})(?![^<]*>)`, "gi"), replacement);
    editor.current.innerHTML = coloredContent;
  };

  window.handleHighlightedWordClick = (event, el) => {
    event.preventDefault();
    event.stopPropagation();
    const word = decodeURIComponent(el.dataset.word);
    const clickedDisplayWord = decodeURIComponent(el.dataset.displayWord || "");
    scrollToAccordion(word, clickedDisplayWord);
  };

  const highLightWords = (word, color) => {
    if (!editor.current || !word) return;

    let content = editor.current.innerHTML;
    const escapedWord = escapeRegex(word);
    const replacement = `<span style="background-color:${color};">${word}</span>`;
    const coloredContent = content?.replace(new RegExp(`(${escapedWord})(?![^<]*>)`, "gi"), replacement);
    const selection = window.getSelection();
    selection.removeAllRanges();
    editor.current.innerHTML = coloredContent;
  };

  const scrollToAccordion = (word, displayword) => {
    const accordionItems = document.querySelectorAll(`.cgsuggestion [id^="accordion-"]`);
    let foundItem = null;
    accordionItems.forEach((item) => {
      const erroredText = item.id.replace("accordion-", "");
      if (erroredText === word && !foundItem) foundItem = item;
    });
    if (foundItem) {
      foundItem.scrollIntoView({ behavior: "smooth", block: "center" });
      const accordionSummary = foundItem.querySelector(".MuiAccordionSummary-root");
      if (accordionSummary) {
        accordionSummary.style.backgroundColor = "#e6f7ff";
        setTimeout(() => { accordionSummary.style.backgroundColor = ""; }, 1000);
      }
      if (expanded !== word) { setExpanded(word); highLightWords(displayword, C.accentLight); }
    }
  };

  const handleAccept = (sentence) => {
    if (!editor.current) return;
    const wrongSentence = sentence.phrase;
    const correctSentence = sentence.corrective_text_phrase;
    const root = editor.current;
    const text = root.innerText;
    const escaped = escapeRegex(wrongSentence || "");
    const updatedText = text.replace(new RegExp(escaped, "gi"), correctSentence);
    root.innerHTML = updatedText;
    const filterSentence = suggestionArray.filter((item) => item.corrective_text !== sentence.corrective_text);
    if (filterSentence.length === 0) { setSentenceResult([]); setIsColorChange(false); setIsSuggestion(false); }
    setSuggestionArray(filterSentence);
    setNewSentences((prev) => [...prev, correctSentence]);
  };

  const handleIgnore = async (sentence) => {
    let filterSentence = _.filter(suggestionArray, (item) => item.value !== sentence.value);
    if (filterSentence.length == 0) { setSentenceResult([]); setIsSuggestion(false); }
    colorWord(sentence.value, sentence.errored_text, "black");
    highLightWords(sentence.value, "white");
    setSuggestionArray(filterSentence);
  };

  useEffect(() => { if (changedSentence?.length > 0) handleFilterValues(changedSentence); }, [changedSentence]);

  const handleFilterValues = (sentence) => {
    sentence.map((item) => {
      filterValues.push({
        corrective_text: item["corrective_text"] || item["corrective_text_phrase"],
        corrective_text_phrase: item["corrective_text_phrase"] || "",
        justification: item["justification"] || "",
        phrase: item["phrase"] || "",
        type_of_error: item["type_of_error"] || "",
        value: item["value"],
        errored_text: item["errored_text"],
      });
    });
    let filterSentence = _.filter(
      filterValues,
      (item) =>
        item["type_of_error"] !== "No error" && item["type_of_error"] !== "No errors" &&
        item["type_of_error"] !== "None" && item["type_of_error"] !== "N/A" &&
        item["type_of_error"] !== "none" &&
        item["justification"] !== "No grammatical errors found." &&
        item["justification"] !== "No error found in the phrase." &&
        item["justification"] !== "" && item["justification"] !== "The sentence is grammatically correct." &&
        item["corrective_text"] !== ""
    );
    let finalFilteredValues = filterSentence.filter(
      (suggestion) => !ignoredSuggestions.includes(suggestion.corrective_text)
    );
    const values = finalFilteredValues.map((item) => item.phrase);
    const correctedSentences = values.map((sentence) =>
      sentence.replace(/\.+/g, ".").split(".").filter((s) => s.trim()).map((s) => { const trimmed = s.trim(); return trimmed.endsWith(".") ? trimmed : trimmed + "."; })
    );
    const flatArray = correctedSentences.flat();
    setNewSentences((prevItems) => [...prevItems, ...flatArray]);
    if (filterSentence.length == 0) { setSentenceResult([]); setIsSuggestion(false); }
    else {
      if (suggestionArray.length == 0) {
        setSuggestionArray(finalFilteredValues);
      } else {
        setSuggestionArray((prevSentences) => {
          const merged = [...prevSentences, ...finalFilteredValues.flat()];
          const seen = new Map();
          return merged.filter((obj) => { if (!seen.has(obj.value)) { seen.set(obj.value, true); return true; } return false; });
        });
      }
      setIsSuggestion(true);
    }
  };

  useEffect(() => {
    if (suggestionArray.length > 0) {
      suggestionArray.map((item) => colorWord(item.value, item.errored_text, "red"));
      setExpanded(suggestionArray[0].errored_text);
      setErrorValue(suggestionArray[0].value);
      highLightWords(suggestionArray[0].value, C.accentLight);
    }
  }, [suggestionArray]);

  const handleExpand = (param) => {
    setErrorValue(param.value);
    if (param.value !== errorValue) highLightWords(errorValue, "white");
    setExpanded(param.errored_text);
    highLightWords(param.value, C.accentLight);
  };

  // ── count by error type ───────────────────────────────────────────────────
  const errorCounts = suggestionArray.reduce((acc, s) => {
    const type = getErrorConfig(s.type_of_error).label;
    acc[type] = (acc[type] || 0) + 1;
    return acc;
  }, {});

  return (
    <Box
      sx={{
        position: "relative",
        minHeight: 0,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      {/* Loading overlay */}
      {suggestionLoader && (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            bgcolor: "rgba(255,255,255,0.85)",
            zIndex: 10,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 1.5,
            borderRadius: R.lg,
          }}
        >
          <BeatLoader size={12} color={C.accent} loading />
          <Typography sx={{ fontSize: "0.8rem", color: C.textMuted, fontWeight: 500 }}>
            Analyzing your text…
          </Typography>
          <LinearProgress
            sx={{
              width: 120,
              height: 3,
              borderRadius: 2,
              bgcolor: C.accentLight,
              "& .MuiLinearProgress-bar": { bgcolor: C.accent },
            }}
          />
        </Box>
      )}

      {/* Error type summary pills */}
      {suggestionArray.length > 0 && (
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 0.75,
            px: 2,
            pb: 1.5,
            pt: 0.5,
          }}
        >
          {Object.entries(errorCounts).map(([type, count]) => {
            const config = getErrorConfig(type);
            return (
              <Chip
                key={type}
                icon={config.icon}
                label={`${type} · ${count}`}
                size="small"
                sx={{
                  height: 22,
                  fontSize: "0.7rem",
                  fontWeight: 700,
                  bgcolor: config.bg,
                  color: config.color,
                  border: `1px solid ${config.color}30`,
                  "& .MuiChip-icon": { color: config.color, ml: 0.5 },
                }}
              />
            );
          })}
        </Box>
      )}

      {/* Suggestion cards */}
      <Box sx={{ px: 2, pb: 2, flex: 1, minHeight: 0, overflowY: "auto", overflowX: "hidden" }}>
        {suggestionArray.length === 0 && !suggestionLoader ? (
          <EmptyState />
        ) : (
          suggestionArray.map((suggestion, i) => (
            <div key={i} className="cgsuggestion" ref={accordionRef}>
              <SuggestionCard
                suggestion={suggestion}
                expanded={expanded}
                onExpand={handleExpand}
                onAccept={handleAccept}
                onIgnore={handleIgnore}
                mobileView={mobileView}
              />
            </div>
          ))
        )}
      </Box>
    </Box>
  );
};

export default SuggestionComp;




